import { render, staticRenderFns } from "./GiveAuth.vue?vue&type=template&id=5b6af14c&scoped=true&"
import script from "./GiveAuth.vue?vue&type=script&lang=js&"
export * from "./GiveAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6af14c",
  null
  
)

export default component.exports